<template>
  <div>
    <DataTable
      v-model:filters="filters"
      v-model:expandedRows="expandedRows"
      :value="items"
      :loading="loading"
      :rows="10"
      :totalRecords="total"
      :rowsPerPageOptions="[10, 25, 50]"
      filterDisplay="row"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      currentPageReportTemplate="Memuat {first} dari {last} data dari total {totalRecords}"
      class="p-datatable-sm"
      row-hover
      paginator
      scrollable
      lazy
      @page="onPage($event)"
      @sort="onSort($event)"
      @filter="onFilter($event)"
    >
      <template #empty>
        <div class="text-center">Tidak ada data.</div>
      </template>
      <template #loading>
        <div class="text-center">Memuat data, harap tunggu...</div>
      </template>
      <Column style="min-width: 3rem; flex: initial" header="" expander />
      <Column
        field="kode"
        header="Kode"
        style="min-width: 12rem"
        headerStyle="min-width: 12rem"
        sortable
      >
        <template #body="{ data }">
          {{ data.ju_no }}
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            type="text"
            v-model="filterModel.value"
            class="p-column-filter"
            @keydown.enter="filterCallback()"
          />
        </template>
      </Column>
      <Column
        dataType="date"
        filter-field="transaction_between"
        field="ju_at"
        header="Tanggal"
        style="min-width: 10rem"
        sortable
      >
        <template #body="{ data }">
          {{ formatDate(data.ju_at) }}
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <CalendarFilter
            ref="calendarFilter"
            v-model="filterModel.value"
            @select="filterCallback()"
          />
        </template>
      </Column>
      <Column field="keterangan" header="Keterangan" style="min-width: 10rem" />
      <Column
        field="total_debit"
        header="Total Debit"
        style="min-width: 8rem; flex-grow: 1; justify-content: flex-end"
      >
        <template #body="{ data }">
          {{ formatCurrency(data.total_debit, 2, 2) }}
        </template>
      </Column>
      <Column
        field="total_kredit"
        header="Total Kredit"
        style="min-width: 8rem; flex-grow: 1; justify-content: flex-end"
      >
        <template #body="{ data }">
          {{ formatCurrency(data.total_kredit, 2, 2) }}
        </template>
      </Column>
      <Column
        field="created_by"
        header="Username"
        style="min-width: 8rem; flex-grow: 1; justify-content: flex-end"
      >
        <template #body="{ data }">
          {{ data.created_by }}
        </template>
      </Column>
      <Column
        style="
          display: flex;
          flex-grow: 1;
          justify-content: flex-end;
          min-width: 200px;
        "
      >
        <template #body="{ data }">
          <Button
            type="button"
            icon="pi pi-print"
            class="p-button-outlined p-button-secondary p-button-text mr-2"
            v-tooltip.top="'Cetak Jurnal'"
            @click="$emit('print', data)"
          />
          <Button
            type="button"
            icon="pi pi-pencil"
            class="p-button-outlined p-button-secondary p-button-text"
            @click="$emit('edit', data)"
          />
          <Button
            type="button"
            icon="pi pi-trash"
            class="p-button-outlined p-button-danger p-button-text"
            @click="$emit('delete', data)"
          />
        </template>
      </Column>
      <template #expansion="slotProps">
        <grid-jurnal-umum-detail
          :items="slotProps.data.detail"
          :show-button="false"
        />
      </template>
    </DataTable>
  </div>
</template>

<script>
import { FilterMatchMode } from 'primevue/api'
import CalendarFilter from '@/components/CalendarFilter'
import { formatCurrency, formatDate } from '@/helpers'
import GridJurnalUmumDetail from '@/components/keuangan/GridJurnalUmumDetail'

export default {
  components: {
    CalendarFilter,
    GridJurnalUmumDetail,
  },
  props: {
    items: {
      type: Array,
      default() {
        return []
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
    gridOptions: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      options: this.gridOptions,
      expandedRows: [],
      filters: {
        kode: { value: null, matchMode: FilterMatchMode.CONTAINS },
        transaction_between: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
      },
    }
  },
  watch: {
    'options.filters'(value) {
      if (!value.transaction_between.value) {
        this.$refs.calendarFilter.clearValueOnly()
      }
    },
  },
  methods: {
    onPage(e) {
      e.page = e.page + 1
      e.sortField = this.options.sortField
      e.sortOrder = this.options.sortOrder
      this.options = e
      this.options.filters = this.filters
      this.loadData()
    },
    onSort(e) {
      this.options = e
      this.loadData()
    },
    onFilter() {
      this.options.page = 1
      this.options.filters = this.filters
      this.loadData()
    },
    loadData() {
      this.$emit('request', this.options)
    },
    formatCurrency(value, minDigit = 0, maxDigit = 0) {
      return formatCurrency(value, minDigit, maxDigit)
    },
    formatDate(value) {
      return formatDate(value)
    },
  },
}
</script>
